package com.hyperether.goodjob.util

import androidx.navigation.NavController
import com.hyperether.goodjob.models.Role
import com.hyperether.goodjob.models.UserStatus
import com.hyperether.goodjob.navigation.*
import com.hyperether.goodjob.repository.prefs.PrefsManager
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch

object NavigationUtil {
    fun getOnboardingScreen(
        prefsManager: PrefsManager,
        isMobile: Boolean
    ): RouteScreen {
        if (!prefsManager.isOnboardingShown()) {
            CoroutineScope(Dispatchers.Main).launch {
                delay(150)
            }
            if (isMobile)
                return Onboarding
            else {
                prefsManager.onBoardingShown(true)
                return Landing
            }
        } else {
            val user = prefsManager.getUser()
            if (user == null || user.confirmStatus == UserStatus.pending.name) {
                return Register
            } else if (user.role.equals(Role.employee.name, ignoreCase = true) ||
                user.role.equals(Role.manager.name, ignoreCase = true) ||
                user.role.equals(Role.superAdmin.name, ignoreCase = true)
            ) {
                // role set, admin with the plan, manager, or employee
                return if (prefsManager.getWorkspaceId().isNotEmpty()) {
                    Dashboard
                } else {
                    Workspace
                }
            } else {
                if (user.planId.isNullOrEmpty()) {
                    // admin without plan:
                    return if (user.workspaceId.isNullOrEmpty()) {
                        // does not belong to workspace:
                        Pricing
                    } else if (prefsManager.getWorkspaceId().isEmpty()) {
                        // has workspace but not set
                        Workspace
                    } else {
                        // had workspace and set it:
                        Dashboard
                    }
                } else if (prefsManager.getWorkspaceId().isEmpty()) {
                    // plan set, workspace not set:
                    return Workspace
                } else {
                    // plan set, workspace set:
                    return Dashboard
                }
            }
        }
    }

    fun isCurrentScreenJobDetails(
        navController: NavController,
        targetJobId: String,
        routePattern: String = "job_details/{jobId}"
    ): Boolean {
        val currentBackStackEntry = navController.currentBackStackEntry
        val currentRoutePattern = currentBackStackEntry?.destination?.route
        val currentJobId = currentBackStackEntry?.destination?.route?.let { route ->
            // Extract jobId from the route string
            val regex = """job_details/([^/]+)""".toRegex()
            regex.find(route)?.groupValues?.get(1)
        }

        return currentRoutePattern == routePattern && currentJobId == targetJobId
    }
}